import React, { useCallback, useEffect, useState, Fragment } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArticleCard } from './ArticleCard';
import { GptAdSlot } from './GptAdSlot';
import { PlusButton } from './PlusButton';
import { ArrowButton } from './ArrowButton';
import { SectionHeader } from './SectionHeader';
const profiles = [{
  name: 'Hubert Boulos',
  title: 'Founder and CEO',
  company: 'Das Kapital'
}, {
  name: 'Tarek Miknas',
  title: 'CEO',
  company: 'FP7McCann MENAT'
}, {
  name: 'Hubert Boulos',
  title: 'Founder and CEO',
  company: 'Das Kapital'
}, {
  name: 'Tarek Miknas',
  title: 'CEO',
  company: 'FP7McCann MENAT'
}, {
  name: 'Hubert Boulos',
  title: 'Founder and CEO',
  company: 'Das Kapital'
}];
const heroSlides = [{
  image: 'https://cdn.magicpatterns.com/uploads/7bt6SVfPLtDKtJDcXwkDSx/Rectangle_31.jpg',
  title: 'The US agencies storming up the World Creative Rankings',
  description: "Special Group, a global independent creative network, was the year's biggest climber in North America."
}, {
  image: 'https://cdn.magicpatterns.com/uploads/7bt6SVfPLtDKtJDcXwkDSx/Rectangle_31.jpg',
  title: 'How MENA brands are redefining global advertising standards',
  description: 'Regional powerhouses are making waves on the international stage with bold creative campaigns and innovative strategies....'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/7bt6SVfPLtDKtJDcXwkDSx/Rectangle_31.jpg',
  title: 'The rise of AI-powered creativity in the advertising industry',
  description: 'From generative visuals to automated copywriting, agencies are embracing artificial intelligence to push creative boundaries....'
}];
const imageVariants = {
  enter: (dir: number) => ({
    x: dir > 0 ? '100%' : '-100%'
  }),
  center: {
    x: '0%'
  },
  exit: (dir: number) => ({
    x: dir > 0 ? '-100%' : '100%'
  })
};
const textVariants = {
  enter: {
    opacity: 0
  },
  center: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
};
function SidebarArticleCard({
  hasImage,
  showPlus,
  imageUrl
}: {
  hasImage?: boolean;
  showPlus?: boolean;
  imageUrl?: string;
}) {
  return <div className="has-radius relative overflow-hidden group cursor-pointer w-full lg:max-w-[285px]" style={{
    aspectRatio: '1 / 1',
    borderRadius: '18.75px',
    backgroundColor: '#D9D9D9'
  }} data-id="element-109">
      {hasImage && <img src={imageUrl || 'https://cdn.magicpatterns.com/patterns/figma-images/TmuSK63UZRrBCoTmT1iulP/1052-30.png'} alt="Branded Article" className="absolute inset-0 w-full h-full object-cover scale-[1.03] group-hover:scale-110 transition-transform duration-500" data-id="element-110" />}
      {hasImage && <div className="absolute inset-0" style={{
      background: 'rgba(107, 107, 107, 0.50)'
    }} data-id="element-111" />}
      <div className="absolute inset-0 p-4 lg:p-5 flex flex-col justify-end" data-id="element-112">
        <h3 className={`mb-6 ${hasImage ? 'text-white' : ''}`} style={{
        fontSize: '35px',
        fontFamily: "'League Gothic', Impact, Arial, sans-serif",
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: '35px',
        letterSpacing: '-1.05px',
        color: hasImage ? '#FFF' : '#000000',
        textShadow: hasImage ? '0 3px 3px rgba(0,0,0,0.25)' : undefined
      }} data-id="element-113">
          The US agencies storming up the World Creative Rankings
        </h3>
        <span style={{
        fontSize: '11.25px',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 400,
        fontStyle: 'normal',
        lineHeight: 'normal',
        textTransform: 'uppercase' as const,
        color: hasImage ? '#FFF' : '#000000'
      }} data-id="element-114">
          By{' '}
          <span style={{
          fontSize: '11.25px',
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 400,
          fontStyle: 'normal',
          lineHeight: 'normal',
          textTransform: 'none' as const,
          color: hasImage ? '#FFF' : '#000000'
        }} data-id="element-115">
            WPP
          </span>
        </span>
      </div>
      {showPlus && <div className="absolute bottom-3 left-1/2 -translate-x-1/2" data-id="element-116">
          <span style={{
        color: '#000000'
      }} className="font-bold text-[30px] lg:text-[40px] leading-none" data-id="element-117">
            +
          </span>
        </div>}
    </div>;
}
export function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState(1);
  const nextSlide = useCallback(() => {
    setDirection(1);
    setCurrentSlide(prev => (prev + 1) % heroSlides.length);
  }, []);
  const prevSlide = () => {
    setDirection(-1);
    setCurrentSlide(prev => (prev - 1 + heroSlides.length) % heroSlides.length);
  };
  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);
  const slide = heroSlides[currentSlide];
  return <section className="site-container" data-id="element-118">
      <div className="flex flex-col lg:flex-row lg:items-start gap-8 lg:gap-4" style={{
      columnGap: '37px'
    }} data-id="element-119">
        {/* ===== LEFT CONTENT AREA ===== */}
        <div className="flex-1 flex flex-col gap-6 min-w-0" data-id="element-120">
          <div className="flex flex-col lg:flex-row lg:items-start gap-6 lg:gap-4" style={{
          columnGap: '37px'
        }} data-id="element-121">
            {/* Left Profiles Column */}
            <div className="flex flex-col flex-shrink-0 order-2 lg:order-1 w-full lg:w-[285px]" data-id="element-122">
              <SectionHeader label="The View" variant="hero" data-id="element-123" />
              <div className="has-radius w-full px-5 pt-8 pb-[30px] -mt-3 flex flex-col" style={{
              backgroundColor: '#D9D9D9',
              borderRadius: '0 18.75px'
            }} data-id="element-124">
                {profiles.map((p, i) => <Fragment key={i} data-id="element-125">
                    <div className="flex items-center cursor-pointer transition-opacity duration-200 hover:opacity-70" data-id="element-126">
                      <img src="https://cdn.magicpatterns.com/patterns/figma-images/TmuSK63UZRrBCoTmT1iulP/1193-9.png" alt={p.name} className="rounded-full object-cover flex-shrink-0" style={{
                    width: '93px',
                    height: '93px',
                    aspectRatio: '1/1'
                  }} data-id="element-127" />
                      <div className="flex flex-col min-w-0" data-id="element-128">
                        <span className="leading-normal" style={{
                      color: '#090909',
                      fontFamily: "'League Gothic', Impact, Arial, sans-serif",
                      fontSize: '25px',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: 'normal'
                    }} data-id="element-129">
                          {p.name}
                        </span>
                        <span className="leading-normal" style={{
                      color: '#000',
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: '11.25px',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: 'normal'
                    }} data-id="element-130">
                          {p.title}
                        </span>
                        <span className="leading-normal" style={{
                      color: '#000',
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: '11.25px',
                      fontStyle: 'normal',
                      fontWeight: 700,
                      lineHeight: 'normal'
                    }} data-id="element-131">
                          {p.company}
                        </span>
                      </div>
                    </div>
                    {i < profiles.length - 1 && <div className="h-px" style={{
                  backgroundColor: '#000',
                  marginLeft: '93px',
                  marginRight: '-20px',
                  marginTop: '6px',
                  marginBottom: '6px'
                }} data-id="element-132" />}
                  </Fragment>)}
              </div>
              <div className="flex justify-center -mt-7 relative z-10" data-id="element-133">
                <PlusButton size="lg" data-id="element-134" />
              </div>
            </div>

            {/* Center Hero Column */}
            <div className="flex-1 flex flex-col min-w-0 lg:mt-[7px] order-1 lg:order-2" data-id="element-135">
              {/* Slider Container */}
              <div className="relative w-full" style={{
              aspectRatio: '960/502'
            }} data-id="element-136">
                {/* Clipping wrapper */}
                <div className="has-radius" style={{
                position: 'absolute',
                inset: 0,
                overflow: 'hidden',
                borderRadius: '0 18.75px'
              }} data-id="element-137">
                  <AnimatePresence initial={false} custom={direction} data-id="element-138">
                    <motion.img key={currentSlide} src={slide.image} alt={slide.title} custom={direction} variants={imageVariants} initial="enter" animate="center" exit="exit" transition={{
                    x: {
                      type: 'tween',
                      duration: 0.5,
                      ease: [0.4, 0, 0.2, 1]
                    }
                  }} style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }} data-id="element-139" />
                  </AnimatePresence>
                </div>
                {/* Arrow buttons — slightly inset on mobile, half in/out on desktop */}
                <ArrowButton direction="left" onClick={prevSlide} size="md" className="absolute top-1/2 -translate-y-1/2 -left-[4px] lg:-left-[37.5px]" data-id="element-140" />
                <ArrowButton direction="right" onClick={nextSlide} size="md" className="absolute top-1/2 -translate-y-1/2 -right-[4px] lg:-right-[37.5px]" data-id="element-141" />
              </div>

              {/* Headline Card - static white bg, text fades */}
              <div className="relative z-10" style={{
              marginTop: '12px'
            }} data-id="element-142">
                <AnimatePresence initial={false} mode="wait" data-id="element-143">
                  <motion.div key={currentSlide} variants={textVariants} initial="enter" animate="center" exit="exit" transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-144">
                    <h1 className="mb-2" style={{
                    color: '#090909',
                    fontSize: '60px',
                    fontFamily: "'League Gothic', Impact, Arial, sans-serif",
                    fontWeight: 400,
                    fontStyle: 'normal',
                    lineHeight: '65px',
                    letterSpacing: 0,
                    display: 'inline-block',
                    width: '100%',
                    wordBreak: 'break-word' as const
                  }} data-id="element-145">
                      {slide.title}
                    </h1>
                    <p style={{
                    color: '#090909',
                    fontSize: '12px',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    lineHeight: '18px'
                  }} data-id="element-146">
                      {slide.description}
                    </p>
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>
          </div>

          {/* ARTICLE ROW */}
          <div className="relative" data-id="element-147">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-[37px]" style={{}} data-id="element-148">
              <ArticleCard imageUrl="https://cdn.magicpatterns.com/uploads/hmd8RTg2dhqgufNWoSEJMx/Rectangle_41.png" category="NEWS" index={0} data-id="element-149" />
              <ArticleCard imageUrl="https://cdn.magicpatterns.com/uploads/fyT1wVaYT9WKKJQgDtrP5M/Rectangle_42.png" category="OPINION" hasShadow index={1} data-id="element-150" />
              <ArticleCard imageUrl="https://cdn.magicpatterns.com/uploads/iFm4zkS1U82HqEHJNgBYw2/Rectangle_52.png" category="INTERVIEW" hasShadow index={2} data-id="element-151" />
            </div>
            <div className="absolute -right-3 lg:-right-5 top-[25%] hidden md:block" data-id="element-152">
              <PlusButton size="sm" data-id="element-153" />
            </div>
          </div>

          {/* NEWSLETTER BAR */}
          <div className="flex flex-col md:flex-row items-center gap-3 lg:gap-5 md:h-[53px]" style={{
          backgroundColor: '#090909',
          padding: '12px 16px',
          borderRadius: '18.75px'
        }} data-id="element-154">
            <span className="uppercase whitespace-nowrap flex-shrink-0" style={{
            color: '#FFF',
            fontFamily: "'League Gothic', Impact, Arial, sans-serif",
            fontSize: '30px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: '3px',
            textTransform: 'uppercase'
          }} data-id="element-155">
              Stay in the know
            </span>
            <div className="relative flex-1 w-full" data-id="element-156">
              <input type="email" placeholder="" className="w-full border-0 outline-none" style={{
              height: '33px',
              backgroundColor: '#FFFFFF',
              borderRadius: '18.75px',
              padding: '0 40px 0 20px',
              color: '#000000',
              fontSize: '12px'
            }} data-id="element-157" />
              <button className="absolute right-4 top-1/2 -translate-y-1/2 hover:opacity-70 transition-opacity" data-id="element-158">
                <img src="https://cdn.magicpatterns.com/patterns/figma-svgs/TmuSK63UZRrBCoTmT1iulP/1058-202.svg" alt="Submit" className="w-4 h-4 lg:w-5 lg:h-5" style={{
                filter: 'brightness(0)'
              }} data-id="element-159" />
              </button>
            </div>
          </div>

          {/* Billboard Ad 970x250 */}
          <div className="w-full flex items-center justify-center overflow-hidden" style={{
          backgroundColor: '#D9D9D9',
          borderRadius: '18.75px'
        }} data-id="element-160">
            <img src="https://cdn.magicpatterns.com/uploads/81wWCkPrdq4acms41GQm8a/Leaderboard_728x90_(1).png" alt="Billboard Ad" className="w-full" style={{
            maxWidth: '970px',
            height: 'auto',
            display: 'block'
          }} data-id="element-161" />
          </div>
        </div>

        {/* ===== RIGHT SIDEBAR ===== */}
        <div className="flex flex-col flex-shrink-0 w-full lg:w-[285px]" data-id="element-162">
          <SectionHeader label="Branded" className="z-20" variant="hero" data-id="element-163" />
          <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 relative z-10 gap-8 lg:gap-[50px]" style={{
          marginTop: '-10px'
        }} data-id="element-164">
            <SidebarArticleCard hasImage imageUrl="https://cdn.magicpatterns.com/uploads/aYF1QP5Y3wHWgLLS1qWKYb/Rectangle_35.png" data-id="element-165" />
            <SidebarArticleCard hasImage imageUrl="https://cdn.magicpatterns.com/uploads/gwehDUY4hnsFmQWhLYgaYP/Rectangle_36.png" data-id="element-166" />
            <SidebarArticleCard hasImage imageUrl="https://cdn.magicpatterns.com/uploads/ffs7nthMqg9NVPFiSaJ6pA/Rectangle_37.png" data-id="element-167" />
            <SidebarArticleCard hasImage imageUrl="https://cdn.magicpatterns.com/uploads/tdbunZReAjoQoGZmDqNX1L/Rectangle_38.png" data-id="element-168" />
          </div>
        </div>
      </div>
    </section>;
}